module.exports = __webpack_public_path__ + "static/media/FooterImg1.ddb5ef58.png";